package com.exura.components.loading

import com.exura.primary
import com.exura.ui.Dimens
import com.exura.ui.Durations
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.TransformOrigin
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.transformOrigin
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariant
import com.varabyte.kobweb.silk.theme.colors.palette.overlay
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.AnimationTimingFunction

sealed interface LoaderOverlayKind : ComponentKind
sealed interface LoaderKind : ComponentKind

val LoaderOverlayStyle = CssStyle<LoaderOverlayKind> {
    base {
        Modifier
            .fillMaxSize()
            .justifyContent(JustifyContent.Center)
    }
}

val LoaderOverlayDimmedVariant = LoaderOverlayStyle.addVariant {
    val palette = colorMode.toPalette()

    base {
        Modifier
            .backgroundColor(palette.overlay.toRgb().copyf(alpha = 0.5f))
    }
}

val LoaderStyle = CssStyle<LoaderKind> {
    val palette = colorMode.toPalette()

    base {
        Modifier
            .animation(
                DoubleHeartbeatSpin.toAnimation(
                    duration = Durations.loaderCycle,
                    timingFunction = AnimationTimingFunction.EaseInOut,
                    iterationCount = AnimationIterationCount.Infinite
                )
            )
            .transformOrigin(TransformOrigin.Center)
            .height(Dimens.spinnerSizeDefault)
            .color(if (colorMode.isLight) palette.primary else palette.primary)

    }
}

val InlineLoaderVariant = LoaderStyle.addVariant {
    base {
        Modifier
            .height(Dimens.iconRelSizeDefault)
    }
}

val LogInLoaderVariant = LoaderStyle.addVariant {
    base {
        Modifier
            .height(Dimens.loggingBoxSpinnerSize)
    }
}
